module.exports = __webpack_public_path__ + "img/torch.6054c4c3.jpg";